import { Button, Typography } from '@mui/material'
import React from 'react'
import { DataGrid } from '@mui/x-data-grid'

const ViewImags = ({ imageData, imageType }) => {
    const columns = [
        {
            field: 'signedLink',
            headerAlign: "center",
            align: "center",
            hideSortIcons: true,
            headerName: 'Image Link',
            flex: 1,
            renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        <Button onClick={() => window.open(row.signedLink, "_blank")}>View Image</Button>
                    </>
                )
            }
        }
    ]

    // Get the appropriate image array based on type
    const getImageArray = () => {
        if (imageType === 'courier') {
            return imageData?.courierImagesS3Link || []
        } else if (imageType === 'merchant') {
            return imageData?.merchantImagesS3Link || []
        }
        return []
    }

    const imageArray = getImageArray()

    return (
        <>
            {imageArray.length > 0 ? (
                <DataGrid
                    columns={columns}
                    autoHeight={true}
                    rows={imageArray}
                    pagination={false}
                    hideFooterPagination={true}
                    rowHeight={40}
                    disableColumnMenu
                    getRowId={(row) => row.key || row.signedLink}
                />
            ) : (
                <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
                    No images available
                </Typography>
            )}
        </>
    )
}

export default ViewImags;
